import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);
export const useI18n = () => useContext(I18nContext) || { lang: "en", setLang: () => {}, t: (k, f) => f || k };

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("resume_studio_lang") || "en");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("resume_studio_lang", l);
    document.documentElement.lang = l;
  }, []);

  const t = useCallback((key, fallback) => {
    const dict = translations[lang] || translations.en;
    return dict[key] || translations.en[key] || fallback || key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};
